const QUICK_VIEW_BOUND = "data-quick-view-bound";
const QUICK_VIEW_SETUP = "data-quick-view-setup";

function initQuickView() {
  const quickViewModal = document.querySelector(".quick-view-container");
  if (!quickViewModal) return;

  const quickViewModalInner = quickViewModal.querySelector(".inner");
  const quickViewClose = quickViewModal.querySelector(".close");
  const sectionName = "tp-quick-view";

  if (!quickViewModal.getAttribute(QUICK_VIEW_SETUP)) {
    quickViewModal.setAttribute(QUICK_VIEW_SETUP, "true");
    const overlay = quickViewModal.querySelector(".overlay");
    if (overlay) {
      overlay.addEventListener("click", () => {
        quickViewModal.classList.remove("active");
        document.querySelector("body").classList.remove("locked");
      });
    }
    if (quickViewClose) {
      quickViewClose.addEventListener("click", () => {
        quickViewModal.classList.remove("active");
        document.querySelector("body").classList.remove("locked");
      });
    }
  }

  const getProductReview = (html) => {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const reviewBlock = parsedHTML.querySelector(".yotpo-widget-instance");
    const reviewAverage = parseFloat(reviewBlock.dataset.average);
    const reviewCount = parseInt(reviewBlock.dataset.count);
    const reviewPlace = quickViewModalInner.querySelector(".yotpo-widget-instance");
    let stars = "";

    function roundToHalf(value) {
      var converted = parseFloat(value);
      var decimal = converted - parseInt(converted, 10);
      decimal = Math.round(decimal * 10);
      if (decimal == 5) {
        return parseInt(converted, 10) + 0.5;
      }
      if (decimal < 3 || decimal > 7) {
        return Math.round(converted);
      }
      return parseInt(converted, 10) + 0.5;
    }

    const reviewAverageRounded = roundToHalf(reviewAverage);
    const floorReviewAverage = Math.floor(reviewAverageRounded);

    for (let i = 1; i <= 5; i++) {
      let icon_offset_1 = i <= floorReviewAverage ? "100%" : "0%";
      let icon_offset_2 = i <= floorReviewAverage ? "100%" : "0%";
      let icon_id = i <= floorReviewAverage ? "9650226208332289" : "7774917110587847";
      if (!Number.isInteger(reviewAverageRounded) && i === floorReviewAverage + 1) {
        icon_offset_1 = "51%";
        icon_offset_2 = "51%";
        icon_id = "7111190679284891";
      }
      stars += `<div class="star-container" style="display: flex; flex-direction: row; margin-right: 3.5px;">
                          <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-labelledby="6067985055909-ada-star-ratings-text" width="15" height="15">
                              <defs>
                              <linearGradient aria-hidden="true" id="yotpo_stars_gradient_0.${icon_id}">
                                <stop offset="${icon_offset_1}" stop-color="#ECA300"></stop>
                                <stop stop-opacity="1" offset="${icon_offset_2}" stop-color="#FFFFFF"></stop>
                              </linearGradient>
                            </defs>
                            <path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#ECA300" fill="url('#yotpo_stars_gradient_0.${icon_id}')"></path>
                          </svg>
                        </div>`;
    }
    let starsWrapper = `<div style="display: flex; flex-direction: row; align-items: center; margin-left: 0px;">${stars}</div>`;
    let starsWidget = `<div class="yotpo-reviews-star-ratings-widget yotpo-star-ratings-widget-override-css yotpo-device-desktop yotpo-display-l" style="display: flex; justify-content: left; flex-direction: row; margin-bottom: 3px;">  
                                <div class="yotpo-widget-clear"> 
                                  <div class="yotpo-bottom-line-scroll-panel" style="display: flex; align-items: flex-start; flex-flow: column wrap; gap: 4px;">
                                    <div class="yotpo-sr-bottom-line-summary" style="display: flex; flex-direction: column; align-items: flex-start; gap: 4px; margin-right: 0px; direction: ltr;"> 
                                      ${starsWrapper} 
                                        <div class="yotpo-sr-bottom-line-right-panel" style="display: flex;">
                                        <div class="yotpo-sr-bottom-line-text yotpo-sr-bottom-line-text--right-panel" style="white-space: nowrap; font-size: 16px; line-height: 18px; text-align: start; font-family: &quot;Open Sans&quot;; font-style: normal; font-weight: 300; color: rgb(44, 44, 44);">
                                        ${reviewCount} Reviews
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                          </div>`;
    if (reviewPlace) reviewPlace.innerHTML = starsWidget;
  };

  document.querySelectorAll("[open-quick-view]").forEach((control) => {
    if (control.getAttribute(QUICK_VIEW_BOUND) === "true") return;
    const handle = control.getAttribute("data-product-handle");
    if (!handle) return;
    control.setAttribute(QUICK_VIEW_BOUND, "true");
    control.addEventListener("click", () => {
      window.axios
        .get(`/products/${handle}?sections=${sectionName}`, {})
        .then(function (response) {
          const html = response.data[sectionName];
          if (quickViewModalInner && html) {
            quickViewModalInner.innerHTML = html;
            getProductReview(html);

            const productForm = quickViewModalInner.querySelector('[action="/cart/add"]');
            if (productForm) {
              productForm.addEventListener("submit", async function (e) {
                e.preventDefault();
                const quantity = productForm.querySelector("input.quantity-selector").value;
                const id = productForm.querySelector("#product-id").value;
                if (quantity && id) {
                  window.cart.add({ items: [{ id: id, quantity: quantity }] });
                  quickViewModal.classList.remove("active");
                  document.querySelector("body").classList.remove("locked");
                }
              });
            }

            document.querySelector("body").classList.add("locked");
            quickViewModal.classList.add("active");
          }
        })
        .catch(function (error) {
          window.log("Error:", error);
        });
    });
  });
}

window.initQuickView = initQuickView;

document.addEventListener("DOMContentLoaded", () => {
  const pageHasRecomendations =
    document.querySelector(".product-recommendations") || false;
  const pageHasWishlist = document.querySelector(".wishlist__grid") || false;
  const timeout = pageHasRecomendations || pageHasWishlist ? 2000 : 0;
  setTimeout(initQuickView, timeout);
});
